<!--
  //app/components/Shared/icons/SearchIcon.vue
  -->

<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
};

withDefaults(defineProps<Props>(), {
  height: 30,
  width: 30,
});
</script>

<template>
  <svg
    class="pointer-events-none"
    fill="none"
    :width="width"
    :height="height"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
</template>

<style scoped></style>
